import React, { useCallback } from "react";
import { usePromise } from "react-use";
import withStyles from "@material-ui/core/styles/withStyles";
import * as yup from "yup";
import { withAuth, requiredString, PropertyForm, NavItem } from "../../common";

const styles = theme => ({
  paper: {
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      minHeight: "calc(100vh - 90px)"
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "calc(100vh - 90px)"
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2)
    }
  },
  toolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.up("md")]: {
      minHeight: "90px !important"
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "90px !important"
    }
  }
});

const form = {
  title: "Reset Password",
  section: { marginTop: 1 },
  field: { padding: 1 },
  hideCancel: true,
  hideReset: true,
  hideSave: true,
  defaultValues: {
    email: null,
    sent: false
  },
  validationSchema: yup.object().shape({
    email: requiredString.email()
  }),
  fieldInfo: {
    info: {
      editor: "content",
      content:
        "Please enter your email address.  A link to reset your password will be sent to you."
    },
    sentInfo: {
      editor: "content"
    },
    email: {
      autoFocus: true,
      label: "Email Address",
      autoComplete: "email",
      required: true
    },
    submit: {
      editor: "submit",
      label: "Reset Password",
      color: "primary",
      variant: "contained"
    },
    getStarted: {
      editor: "content",
      content: () => <NavItem url="/">Get Started</NavItem>
    }
  },
  sections: [
    {
      hidden: vals => vals.sent,
      layout: [["info"], ["email"], ["submit"]]
    },
    {
      hidden: vals => !vals.sent,
      layout: [["sentInfo"], ["getStarted"]]
    }
  ]
};

const PasswordReset = ({ classes, resetPassword }) => {
  const mounted = usePromise();

  const onSubmit = useCallback(
    function onSubmit(vals, form) {
      mounted(resetPassword(vals.email))
        .then(result => {
          if (result.success) {
            form.setFieldValue(
              "sentInfo",
              "Instructions on how to reset your password have been sent to your email address."
            );
            form.setFieldValue("sent", true);
          } else {
            form.setFieldValue(
              "sentInfo",
              "An error has occurred.  Please try later."
            );
            form.setFieldValue("sent", true);
          }

          form.setSubmitting(false);
        })
        .catch(err => {
          form.setFieldValue(
            "sentInfo",
            "An error has occurred.  Please try later."
          );
          form.setFieldValue("sent", true);
          form.setSubmitting(false);
        });
    },
    [resetPassword, mounted]
  );

  return (
    <div className={classes.paper}>
      <div className={classes.toolbar} />

      <PropertyForm {...form} onSubmit={onSubmit} />
    </div>
  );
};

export default withStyles(styles)(withAuth(PasswordReset));
